import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import { useFaqs } from "../../context";
import ActionButtons from "./components/ActionButtons";
import Tabs from "./components/Tabs";
import General from "./components/Tabs/Content/General";
import Translations from "./components/Tabs/Content/Translations";
import { FaqDetailsProvider, useFaqDetails } from "./context";
import { FaqDetailsTabs } from "./context/types";
import DrawerSkeleton from "./skeleton";

const FaqDetailsDrawerContainer: FC = () => (
  <FaqDetailsProvider>
    <FaqDetailsDrawer />
  </FaqDetailsProvider>
);

const FaqDetailsDrawer: FC = () => {
  const { faqDetailsDrawer } = useFaqs();
  const { faqData, handleDrawerClose, isLoading, selectedTab } =
    useFaqDetails();

  const TAB_CONTENT: Record<FaqDetailsTabs, FC> = {
    [FaqDetailsTabs.General]: General,
    [FaqDetailsTabs.Translations]: Translations,
  };
  const ContentComponent = TAB_CONTENT[selectedTab];

  const title = faqData ? "Edit FAQ" : "Add new FAQ";
  return (
    <Drawer
      title={title}
      isOpen={faqDetailsDrawer.isOpen}
      onCloseDrawer={handleDrawerClose}
      headingRight={<ActionButtons />}
      headingBottom={<Tabs />}
    >
      {isLoading && <DrawerSkeleton />}
      {!isLoading && <ContentComponent />}
    </Drawer>
  );
};

export default FaqDetailsDrawerContainer;
